<template>
  <div class="main-content">
    <div class="container">
      <h1>Gizlilik Sözleşmesi</h1>
      <div v-html="getHtml && getHtml.value ? getHtml.value : ''"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gizlilikSozlesmesi",
  data(){
    return{
      data:""
    }
  },
  computed: {
    getHtml: {
      get() {
        return this.$store.getters.getSettings("privacy_policy");
      },
    },
  },
};
</script>

